/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { PrfDelSync01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const prfDelSync01ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const prfDelSync01FetchPrfDelSync01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const prfDelSync01FetchPrfDelSync01Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const prfDelSync01AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const prfDelSync01RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const prfDelSync01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const prfDelSync01SyncLoading = (state, { boolean }) => ({
  ...state,
  syncIsLoading: boolean
});

export const prfDelSync01SyncNowSuccess = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [PrfDelSync01Types.PRF_DEL_SYNC01_RESET_TIMESTAMP]: prfDelSync01ResetTimestamp,
  [PrfDelSync01Types.PRF_DEL_SYNC01_FETCH_PRF_DEL_SYNC01_LOADING]: prfDelSync01FetchPrfDelSync01Loading,
  [PrfDelSync01Types.PRF_DEL_SYNC01_FETCH_PRF_DEL_SYNC01_SUCCESS]: prfDelSync01FetchPrfDelSync01Success,
  [PrfDelSync01Types.PRF_DEL_SYNC01_ADD_SELECTED_DOCUMENTS]: prfDelSync01AddSelectedDocuments,
  [PrfDelSync01Types.PRF_DEL_SYNC01_REMOVE_SELECTED_DOCUMENTS]: prfDelSync01RemoveSelectedDocuments,
  [PrfDelSync01Types.PRF_DEL_SYNC01_SET_WORKSPACE_VISIBLE]: prfDelSync01SetWorkspaceVisible,
  [PrfDelSync01Types.PRF_DEL_SYNC01_SYNC_LOADING]: prfDelSync01SyncLoading,
  [PrfDelSync01Types.PRF_DEL_SYNC01_SYNC_NOW_SUCCESS]: prfDelSync01SyncNowSuccess
});
